module.exports = __webpack_public_path__ + "media/images/emblems/Kloten-blazon-c7b5538a75a731fbaced0a68704d6981.svg";